//#region redux
import { profileRoutineSnoozed } from "store/actions/profileRoutineActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import useSnoozeAction from "components/common/useSnoozeAction";
//#endregion

function useProfileRoutineSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch = useDispatch();

  const onSnoozeRoutineSuccess = () => {
    dispatch(profileRoutineSnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(id, WintSuperkollAPIModel.TodoType.ProfileRoutine, onSnoozeRoutineSuccess);

  return snoozeAction;
}

export default useProfileRoutineSnoozeAction;
